export default {
  name: "settings",
  path: "/settings",
  component: () => import("@/views/member/settings"),
  redirect: {
    name: "Control"
  },
  meta: {
    layout: "default",
    isActive: false,
    text: "설정",
    icon: "setting.svg"
  },
  children: [
    {
      name: "Control",
      path: "/settings/control",
      component: () => import("@/views/member/settings/pages/control"),
      meta: {
        menuMember: true,
        text: "회사 제어",
        isActive: false
      }
    },
    {
      name: "GameCode",
      path: "/settings/gameCode",
      component: () => import("@/views/member/settings/pages/code"),
      meta: {
        menuMember: true,
        text: "게임코드관리",
        isActive: false
      }
    },
    {
      name: "PortfolioAccess",
      path: "/settings/portfolio-access",
      component: () => import("@/views/member/settings/pages/portfolioAccess"),
      meta: {
        menuMember: true,
        text: "포트폴리오 열람 관리",
        isActive: false
      }
    }
  ]
};
